var map = {
	"./apple-laurel-da-DK.svg": 65318,
	"./apple-laurel-de-DE.svg": 45780,
	"./apple-laurel-en-GB.svg": 41934,
	"./apple-laurel-en-US.svg": 94757,
	"./apple-laurel-es-ES.svg": 90686,
	"./apple-laurel-es-MX.svg": 54493,
	"./apple-laurel-fr-FR.svg": 91038,
	"./apple-laurel-it-IT.svg": 80860,
	"./apple-laurel-nb-NO.svg": 7203,
	"./apple-laurel-nl-NL.svg": 7834,
	"./apple-laurel-pl-PL.svg": 21298,
	"./apple-laurel-pt-BR.svg": 40254,
	"./apple-laurel-pt-PT.svg": 69074,
	"./apple-laurel-sv-SE.svg": 799
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87083;